import { Col, Container, Navbar, Row } from 'react-bootstrap';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';

import DownloadCTA from '../DownloadCTA';
import Footer from '../Footer';
import MainNav from '../MainNav';
import OnboardingHero from '../OnboardingHero';
import PropTypes from 'prop-types';
import { getUserMpans } from '../../api/SmartMeter';
import logo from '../../assets/svg/loop-logo.svg';
import styled from 'styled-components';

const StyledNavbarBrand = styled(Navbar.Brand)`
  padding-left: 22px;
  padding-top: 0;
`;

const styles = {
  container: {
    minHeight: '100vh',
    background: '#f5f5f5',
  },
  darkBg: {
    background: '#0c1f28',
  },
};

const AltLayout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isOnboarded, setIsOnboarded] = useState(true);

  useEffect(() => {
    getUserMpans().then(userMpans => setIsOnboarded(!!userMpans?.length));
  }, []);

  return (
    <Container fluid style={styles.container} className="d-flex flex-column">
      <Row style={styles.darkBg}>
        <Col className="p-0">
          <Navbar collapseOnSelect expand="lg">
            <StyledNavbarBrand href="/">
              <img src={logo} alt="Loop Energy" />
            </StyledNavbarBrand>
            <MainNav navigate={navigate} />
          </Navbar>
        </Col>
      </Row>
      {!isOnboarded && (
        <Row>
          <OnboardingHero />
        </Row>
      )}
      <Row className="flex-fill">
        <Col className="p-0">
          <div className="d-flex justify-content-center">{children}</div>
        </Col>
      </Row>
      <Row className="d-flex justify-content-center p-0 app-cta-space appstore-footer">
        <DownloadCTA />
      </Row>
      <Footer location={location} />
    </Container>
  );
};

AltLayout.propTypes = {
  children: PropTypes.node.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
};

export default AltLayout;
